import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from "vuex";
import GenericModal from "@Shared/components/modals/generic-modal";
import QuickActions from "../header-components/quick-actions.vue";
import { CREATE_PROFILE_QUICK_REMINDER, CREATE_PROFILE_QUICK_NOTE } from "@Broker/@Modules/clients/board/store/board-actions";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AddActivityNoteModal",
  components: {
    GenericModal,
    QuickActions,
    SimpleButton
  },
  props: {
    clientProfileId: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      localClientProfileId: this.clientProfileId,
      note: {
        description: ""
      },
      reminder: {
        scheduledDate: "",
        scheduledTime: "",
        description: ""
      },
      assignees: [],
      buttonIsLoading: false,
      invalidNote: true,
      invalidReminder: true
    };
  },
  computed: _objectSpread({}, mapState("AccountStore", {
    currentUsername(state) {
      return state.userDetails.username;
    }
  })),
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [CREATE_PROFILE_QUICK_REMINDER, CREATE_PROFILE_QUICK_NOTE])), {}, {
    handleShow() {
      const {
        modalData
      } = this.$refs.modal;
      this.localClientProfileId = modalData.clientProfileId;
    },
    handleHidden() {
      this.resetFields();
    },
    activeItem(tab) {
      return this.currentTab === tab;
    },
    setCurrentTab(tab) {
      this.$emit("tab", tab);
    },
    resetFields() {
      this.note = {
        description: ""
      };
      this.reminder = {
        scheduledDate: "",
        scheduledTime: "",
        description: "",
        assignees: []
      };
      this.invalidNote = true;
      this.invalidReminder = true;
    },
    async handleSubmit() {
      this.buttonIsLoading = true;
      try {
        const promises = [];
        if (!this.invalidNote) {
          promises.push(this.CREATE_PROFILE_QUICK_NOTE({
            note: this.note.description,
            clientProfileId: this.localClientProfileId
          }));
        }
        if (!this.invalidReminder) {
          promises.push(this.CREATE_PROFILE_QUICK_REMINDER({
            reminder: this.reminder,
            clientProfileId: this.localClientProfileId
          }));
        }
        await _Promise.all(promises);
        this.buttonIsLoading = false;
        this.$refs.modal.hide();
      } catch (e) {
        this.buttonIsLoading = false;
      }
    },
    updateQuickActions(type, data) {
      switch (type) {
        case "follow-up":
          this.reminder = _objectSpread({}, data);
          break;
        case "note":
          this.note.description = data;
          break;
      }
    },
    handleValidationChange(type, isValid) {
      if (type === "follow-up") {
        this.invalidReminder = !isValid;
        return;
      }
      if (type === "note") {
        this.invalidNote = !isValid;
        return;
      }
    }
  })
});